import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import Service from "../../services/InterventionEvents";
import * as Actions from "../actions/InterventionEvents";

import {
  INTERVENTION_EVENTS_LIST_ALL,
  INTERVENTION_EVENTS_CREATE,
  INTERVENTION_EVENTS_DELETE,
  INTERVENTION_EVENTS_UPDATE
} from "../../constants/ActionTypes";
import { notificationMessage } from "../reducers/FeedbackMessage";

const getCompanyStore = state => state.company;

const listAllInterventionEventsRequest = async id =>
  await Service.listAllInterventionEvents(id)
    .then(actions => actions)
    .catch(error => {
      throw error;
    });

const createInterventionEventRequest = async data =>
  await Service.createInterventionEvent(data)
    .then(actions => actions)
    .catch(error => {
      throw error;
    });

const deleteInterventionEventRequest = async id =>
  await Service.deleteInterventionEvent(id)
    .then(actions => actions)
    .catch(error => {
      throw error;
    });

const updateInterventionEventRequest = async data =>
  await Service.updateInterventionEvent(data)
    .then(actions => actions)
    .catch(error => {
      throw error;
    });

function* listAllInterventionEvents({ payload }) {
  try {
    yield put(Actions.interventionEventsComponentVisible(true));
    const events = yield call(listAllInterventionEventsRequest, payload);
    yield put(Actions.interventionEventsComponentVisible(false));
    yield put(Actions.interventionEventsListSuccess(events));
  } catch (error) {
    yield put(Actions.interventionEventsComponentVisible(false));
    yield put(Actions.interventionEventsListError());
  }
}

function* createInterventionEvent({ payload }) {
  try {
    const event = yield call(createInterventionEventRequest, payload);
    yield put(Actions.interventionEventsCreateSuccess(event));
    yield put(Actions.interventionEventsModalVisible(false));
    yield put(
      notificationMessage(
        "notifications.intervention.create.success",
        "success"
      )
    );
    try {
      const { company } = yield select(getCompanyStore);
      yield put(Actions.interventionEventsListAll(company._id));
    } catch (error) {
      yield put(
        notificationMessage("notifications.intervention.list.error", "error")
      );
    }
  } catch (error) {
    yield put(Actions.interventionEventsCreateError());
    yield put(
      notificationMessage("notifications.intervention.create.error", "error")
    );
  }
}

function* updateInterventionEvent({ payload }) {
  try {
    yield call(updateInterventionEventRequest, payload);
    yield put(Actions.interventionEventsUpdateSuccess());
    yield put(Actions.interventionEventsModalVisible(false));
    yield put(
      notificationMessage(
        "notifications.intervention.update.success",
        "success"
      )
    );
    try {
      const { company } = yield select(getCompanyStore);
      yield put(Actions.interventionEventsListAll(company._id));
    } catch (error) {
      yield put(
        notificationMessage("notifications.intervention.list.error", "error")
      );
    }
  } catch (error) {
    yield put(Actions.interventionEventsUpdateError());
    yield put(
      notificationMessage("notifications.intervention.update.error", "error")
    );
  }
}

function* deleteInterventionEvent({ payload }) {
  try {
    yield call(deleteInterventionEventRequest, payload);
    yield put(Actions.interventionEventsDeleteSuccess());
    yield put(
      notificationMessage(
        "notifications.intervention.delete.success",
        "success"
      )
    );
    try {
      const { company } = yield select(getCompanyStore);
      yield put(Actions.interventionEventsListAll(company._id));
    } catch (error) {
      yield put(
        notificationMessage("notifications.intervention.list.error", "error")
      );
    }
  } catch (error) {
    yield put(Actions.interventionEventsDeleteError());
    yield put(
      notificationMessage("notifications.intervention.delete.error", "error")
    );
  }
}

export function* ListAllInterventionEventsSaga() {
  yield takeLatest(INTERVENTION_EVENTS_LIST_ALL, listAllInterventionEvents);
}

export function* createInterventionEventSaga() {
  yield takeLatest(INTERVENTION_EVENTS_CREATE, createInterventionEvent);
}

export function* deleteInterventionEventSaga() {
  yield takeLatest(INTERVENTION_EVENTS_DELETE, deleteInterventionEvent);
}

export function* updateInterventionEvenSaga() {
  yield takeLatest(INTERVENTION_EVENTS_UPDATE, updateInterventionEvent);
}

export default function* rootSaga() {
  yield all([
    fork(ListAllInterventionEventsSaga),
    fork(createInterventionEventSaga),
    fork(deleteInterventionEventSaga),
    fork(updateInterventionEvenSaga)
  ]);
}
